import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '../../../common/components';

const S = {
  Button: styled(Button)`
    padding: 4px 12px;
    border-color: ${({ theme }) => theme.palette.grey[400]};
    color: ${({ theme }) => theme.palette.grey[700]};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    font-weight: 500;
  `,
};

const DeduplicateButton = ({ className }) => (
  <S.Button className={className} type="button" variant="outlined">
    중복 연락처 제거
  </S.Button>
);

DeduplicateButton.propTypes = {
  className: PropTypes.string,
};

DeduplicateButton.defaultProps = {
  className: undefined,
};

export default DeduplicateButton;
